// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconUsdt0 } from "../../../icons/mono/build/icon-usdt0.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const UsdtZeroIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconUsdt0.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  UsdtZeroIcon.displayName = 'UsdtZeroIcon';
}

export default UsdtZeroIcon;